var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.error)?_c('div',{staticClass:"d-flex"},[_c('app-ad',{attrs:{"max-width":"360","outlined":""}},[_c('ad-script',{attrs:{"id":"carbonads-script","script-id":"_carbonads_js","src":"//cdn.carbonads.com/carbon.js?serve=CWYDC27I&placement=v2vuetifyjscom"},on:{"script:error":function($event){_vm.error = true}}})],1)],1):_c('random-ad')
}
var staticRenderFns = []

export { render, staticRenderFns }